// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { StyledConsentsListItem } from './ConsentsListItem.styles';
import { ConsentsListItemProps } from './ConsentsListItem.types';
import { ConsentHeaderList } from './ConsentHeaderList';
import { ConsentCheckList } from './ConsentCheckList';

export const ConsentsListItem: FC<ConsentsListItemProps> = ({
  linkBehavior,
  consentData,
  showTopDivider,
  showBottomDivider,
  consentSectionType,
  validateErrors,
  onModalOpen,
  onCheckboxToggle,
  onLinkClickInHeader,
  onLinkClickInCheckbox,
  closeAccordionBtnLabel,
  openAccordionBtnLabel,
}) => {
  return (
    <StyledConsentsListItem
      data-testid="legal-ConsentListItem"
      data-component-name="m-legal-ConsentListItem"
      className={consentData.containerClassNameOverride ?? `m-consent-list ${consentData.containerClassName ?? ''}`}
    >
      {showTopDivider && <hr className="my-5" />}
      {consentData.headers && (
        <ConsentHeaderList
          consentHeader={consentData.headers}
          headerTextStyle="h4"
          headerFontSize="xs"
          subHeaderTextStyle="h6"
          subHeaderFontSize="xs"
          onLinkClickInHeader={onLinkClickInHeader}
        />
      )}
      <ConsentCheckList
        linkBehavior={linkBehavior}
        consentData={consentData}
        consentSectionType={consentSectionType}
        validateErrors={validateErrors}
        onModalOpen={onModalOpen}
        onCheckboxToggle={onCheckboxToggle}
        onLinkClickInCheckbox={onLinkClickInCheckbox}
        closeAccordionBtnLabel={closeAccordionBtnLabel}
        openAccordionBtnLabel={openAccordionBtnLabel}
      />
      {showBottomDivider && <hr className="my-5" />}
    </StyledConsentsListItem>
  );
};
